import AmdrImport  from "./AmdrImport";

export default AmdrImport;
